import { EventEmitter } from "events";

export class EventName {
    static LOAD_COMPLETE = "LOAD_COMPLETE";
    static USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
    static USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
    static USER_REGISTER_FAILED = "USER_REGISTER_FAILED";
    static FORGET_PWD_SUCCESS = "FORGET_PWD_SUCCESS";
    static FORGET_PWD_FAILED = "FORGET_PWD_FAILED";
    static ON_MODIFY_NAME = "ON_MODIFY_NAME";
    static ON_UPLOAD_AVATAR = "ON_UPLOAD_AVATAR";
    static COMMENT_MAIN_ROUTER = "COMMENT_MAIN_ROUTER";
    static COMMENT_MAIN_ROUTER_WHERE = "COMMENT_MAIN_ROUTER_WHERE";


    static MESSAGE_GETUSERMSGLIST = 'MESSAGE_GETUSERMSGLIST';
    static MISSION_GETLIST = 'MISSION_GETLIST';
    static SHOW_DIALOG = 'SHOW_DIALOG';
    static REMOVE_DIALOG = 'REMOVE_DIALOG';
    static HOME_REFRESH = 'HOME_REFRESH';
    static HOME_SWIPER_INDEX = 'HOME_SWIPER_INDEX';

    static UI_CLOSE_PERMANENT_PAGE = "UI_CLOSE_PERMANENT_PAGE";
    static EVENT_TIM_MESSAGE_RECEIVED = 'EVENT_TIM_MESSAGE_RECEIVED';
    static EVENT_TIM_READY = 'EVENT_TIM_READY';

    static EVENT_UPDATE_USERINFO = 'EVENT_UPDATE_USERINFO';
    static EVENT_SHOW_BARRAGE = 'EVENT_SHOW_BARRAGE';
    static EVENT_BARRAGE_MSG = 'EVENT_BARRAGE_MSG';

}

var DeviceEventEmitter = new EventEmitter();

export default DeviceEventEmitter;